export default __webpack_public_path__ + "a36d6cfe53027d8d6de4be26f50f222e.svg";